import { render, staticRenderFns } from "./CIList.vue?vue&type=template&id=1ff7662e&scoped=true&"
import script from "./CIList.vue?vue&type=script&lang=js&"
export * from "./CIList.vue?vue&type=script&lang=js&"
import style0 from "./CIList.vue?vue&type=style&index=0&id=1ff7662e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7662e",
  null
  
)

export default component.exports